import { initHubSpotForms } from '../utils/hubspot-forms.js';

const init = () => initHubSpotForms();

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
